<template>
  <v-snackbar
    v-model="snackbar"
    :color="color"
    :timeout="timeout"
    :top="true"
  >
    <div style="display: flex; align-content: center; align-items: center;">
      <span>{{ text }}</span>
      <a v-if="url !== ''" :href="url" target="_blank">{{ textUrl }}</a>
      <v-btn
        dark
        text
        icon
        style="margin-left: auto;"
        @click="snackbar = false"
      >
        <v-icon>
          fas fa-times
        </v-icon>
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>

export default {
    name: 'SnackBar',
    data: () => ({
        snackbar: false,
        color: 'success',
        timeout: 3000,
        url: '',
        textUrl: '',
        text: ''
    }),
    created () {
        this.$root.$off('show-snackbar');
        this.$root.$on('show-snackbar', (event) => {
            this.showSnackbar(event);
        });
        this.$root.$on('close-snackbar', (event) => {
            this.closeSnackbar(event);
        });
    },
    methods: {
        showSnackbar (event) {
            this.$data.snackbar = true;
            this.$data.color = event.color || 'success';
            this.$data.timeout = event.timeout || 3000;
            this.$data.text = event.message;
            this.$data.url = event.url || '';
            this.$data.textUrl = event.textUrl || '';
        },
        closeSnackbar () {
            this.$data.snackbar = false;
        },
    }
};
</script>
